class NappiCartPromise extends HTMLElement {
  static KEY = "nappi:detected-country";
  connectedCallback() {
    this.output = this.querySelector("[data-promise-text]");
    if (!this.output || !this.dataset.template) return;
    this.template = this.dataset.template;
    this.fallback = this.dataset.fallback;
    if (this.dataset.thresholdShopCents) {
      const amount = this.#convertedAmount();
      if (!amount) return;
      this.template = this.template.split("[amount]").join(amount);
      if (this.fallback) this.fallback = this.fallback.split("[amount]").join(amount);
      this.#write(this.output.querySelector("strong")?.textContent.trim() || "");
      this.output.hidden = false;
    }
    this.#refine();
  }
  /* Seuil converti dans la devise du panier, écrit comme Shopify l'écrit sur
     ce marché ; sans centimes s'il tombe juste, comme en devise boutique. */
  #convertedAmount() {
    const money = window.NappiMoney;
    if (!money) return null;
    const cents = money.seuil({
      seuilBoutique: this.dataset.thresholdShopCents,
      devisePanier: this.dataset.cartCurrency,
      deviseBoutique: this.dataset.shopCurrency
    });
    const gabarit = money.gabarit(this.dataset.moneySample);
    if (cents === null || !gabarit) return null;
    return money.formater(cents, gabarit, { sansDecimales: cents % 100 === 0 });
  }
  async #refine() {
    const code = await this.#detect();
    if (!code || !this.isConnected) return;
    const zone = (this.dataset.countries || "").split(",").map((c) => c.trim().toUpperCase()).filter(Boolean);
    if (zone.length && !zone.includes(code)) {
      this.#outsideZone();
      return;
    }
    this.#write(this.#countryName(code));
  }
  async #detect() {
    let code = null;
    try {
      code = sessionStorage.getItem(NappiCartPromise.KEY);
    } catch (e) {
    }
    if (!code) {
      try {
        const res = await fetch("/browsing_context_suggestions.json", { headers: { Accept: "application/json" } });
        const data = await res.json();
        code = data?.detected_values?.country?.handle || null;
        if (code) {
          try {
            sessionStorage.setItem(NappiCartPromise.KEY, code);
          } catch (e) {
          }
        }
      } catch (e) {
        return null;
      }
    }
    return /^[A-Z]{2}$/.test(code || "") ? code : null;
  }
  /* Le nom complet plutôt que le code : « livraison offerte vers FR » se lit
     mal dans une phrase. Intl.DisplayNames suit la langue de la page ; si le
     navigateur ne la connaît pas, le code reste préférable à rien. */
  #countryName(code) {
    try {
      const lang = document.documentElement.lang || "en";
      return new Intl.DisplayNames([lang], { type: "region" }).of(code) || code;
    } catch (e) {
      return code;
    }
  }
  /* Le gabarit vient d'un réglage marchand : on assemble des nœuds de texte,
     jamais du HTML. Le nom du pays est mis en gras, comme dans la barre
     d'expédition de la fiche produit. */
  #write(name) {
    const parts = this.template.split("[country]");
    this.output.textContent = "";
    this.output.append(parts[0] || "");
    if (parts.length > 1) {
      const strong = document.createElement("strong");
      strong.textContent = name;
      this.output.append(strong, parts.slice(1).join("[country]"));
    }
  }
  #outsideZone() {
    const fallback = this.fallback;
    if (fallback) {
      this.output.textContent = fallback;
      return;
    }
    this.output.hidden = true;
  }
}
if (!customElements.get("nappi-cart-promise")) {
  customElements.define("nappi-cart-promise", NappiCartPromise);
}
